import {PuiRadioGroup} from "@portnet/ui";
import React from "react";

const AppRadioGroup = React.forwardRef((props, ref) => (
  <PuiRadioGroup ref={ref} {...props} />
));

export default AppRadioGroup;
